import React from 'react';

import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

import {gt} from 'app/utils/i18n';
type Props = {
  advancedModeEnabled?: boolean;
  stepsLength?: number;
  toggleAdvancedMode?: () => any;
  numCollapsedSteps?: number;
  onToggleAllStepsCollapse?: (value: boolean) => any;
};
type MenuItemType = {
  icon: string;
  text: string;
  itemClass?: string;
  condition: () => boolean;
  onClick: () => any;
};

export function ProcedureHeaderOptionsDropdown({
  onToggleAllStepsCollapse,
  toggleAdvancedMode,
  numCollapsedSteps = 0,
  stepsLength = 0,
  advancedModeEnabled = false,
}: Props) {
  const items: Array<MenuItemType> = [
    {
      icon: `far fa-fw fa-${advancedModeEnabled ? 'check-' : ''}square`,
      text: gt('Advanced mode'),
      condition: () => showAdvancedMode(),
      onClick: () => toggleAdvancedMode && toggleAdvancedMode(),
    },
    {
      icon: 'fa fa-fw fa-chevron-down',
      text: gt('Expand all steps'),
      condition: () => showStepsControl() && numCollapsedSteps > 0,
      onClick: () =>
        onToggleAllStepsCollapse && onToggleAllStepsCollapse(false),
    },
    {
      icon: 'fa fa-fw fa-chevron-up',
      text: gt('Collapse all steps'),
      condition: () => showStepsControl() && numCollapsedSteps < stepsLength,
      onClick: () => onToggleAllStepsCollapse && onToggleAllStepsCollapse(true),
    },
  ].filter((item) => item.condition());

  function showAdvancedMode() {
    return toggleAdvancedMode != null;
  }

  function showStepsControl() {
    return onToggleAllStepsCollapse != null;
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <span className="menu-options">
      <UncontrolledDropdown tag={'span'}>
        <DropdownToggle color="link" className="btn-sm px-3">
          <i className="fa fa-ellipsis-v" />
        </DropdownToggle>
        <DropdownMenu right>
          {items.map((item, index) => (
            <DropdownItem
              key={index}
              onClick={item.onClick}
              className={item.itemClass || ''}
            >
              <i className={item.icon} /> {item.text}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    </span>
  );
}
